import React, {useEffect, useState} from 'react';
import './contentBlocker.scss';
import htmlTruncate from 'html-truncate';
import {Col, Row, Tag} from "antd";
import { SlideshowLightbox } from "lightbox.js-react";
import {Card} from "reactstrap";
import {CardAudience} from "../../pages/audience/cardAudience";
import dayjs from "dayjs";
import PrideMusicCard from "../GenericSection/prideMusicCard";
import {ItemJobPublished} from "../../pages/jobBank/itemJobPublished";
import {ItemDirectory} from "../../pages/directory/itemDirectory";
import InterestGroupCard from "../GenericSection/interestGroupCard";
import { useValidTokenFromStorage} from "../../hooks/authHook";
import FormLogin from "../formLogin/formLogin";
import moment from "moment";
import FormRegister from "../formRegister/formRegister";
import {MessageSuccess} from "../messageSuccess/messageSuccess";

const ContentBlocker = ({
    content = null ,
    typeContent = "",
    handleClick,
    limitArray = 4,
    limitCharacters = 0.2,
    title = "",
    isAdmin, sectionOn, profileId, ///economia I
}) => {
    const [isLogin, setIsLogin] = useState(false);
    const [isArrayContent, setIsArrayContent] = useState(false);
    const [truncatedContent, setTruncatedContent] = useState(null);
    const now = dayjs();
    const [contentData, setContentData] = useState([]);
    const [contentType, setContentType] = useState(null);
    const [isFormLogin, setIsFormLogin] = useState(true);
    const [isFormSuccess, setIsFormSuccess] = useState(false);
    const [userRegistered, setUserRegistered] = useState({});
    const validateToken = useValidTokenFromStorage();
    const [isFormRegister, setIsFormRegister] = useState(false);
    const [dataMessageSuccess, setDataMessageSuccess] = useState({title: "", description: ""});
    const [msg, setMsg] = useState("");
    const [statusForm, setStatusForm] = useState(false);

    const handleReset = () => {
        setIsFormLogin(true);
        setIsFormSuccess(false);
        setIsLogin(false)
    };

    useEffect(() => {
        if (!content) return;

        const isArray = Array.isArray(content);
        setIsArrayContent(isArray);

        if (isArray) {
            const limitedArray = userRegistered ? content : content.slice(0, limitArray);
            setTruncatedContent([...limitedArray]);
        } else if (typeof content === 'string') {
            const maxChars = Math.floor(content.length * limitCharacters);
            const newContent = userRegistered
                ? content
                : htmlTruncate(content, maxChars, { ellipsis: '...' });

            setTruncatedContent(newContent);
        }
    }, [JSON.stringify(content), userRegistered]);

    const handleFormSubmit = (value,text,description,statusForm, isRegister) => {
        setIsFormSuccess(value);
        setIsFormRegister(isRegister);
        setDataMessageSuccess({title: text, description: description});
        setStatusForm(statusForm);
    }

    const isUserLoggedIn = () => {
        if(validateToken)
            setUserRegistered(true);
        else
            setUserRegistered(false);
    }

    useEffect(() => {
        if (!isArrayContent || !truncatedContent) {
            setContentData([]);
            setContentType(null);
            return;
        }

        setContentData(truncatedContent);
        setContentType(typeContent);
    }, [truncatedContent, typeContent, isArrayContent]);

    useEffect(() => {
        isUserLoggedIn();
    },[])

    return (
        <>
            <div className={"content-blocker__article"}>
                {contentType === "billboard" && (
                    <div className="content_body_items">
                        {contentData.map((item, index) => (
                            <Card
                                className={"card-pride-ticket"}
                                lang={"en"}
                                onClick={() => handleClick(item.eventUrl)}
                                key={index}
                            >
                                <div className="card_ticket_poster">
                                    <img
                                        className="poster__blur"
                                        src={item.eventImage}
                                        alt={item.eventName}
                                        title={item.eventName}
                                    />
                                    <img
                                        src={item.eventImage}
                                        alt={item.eventName}
                                        title={item.eventName}
                                    />
                                </div>

                                <div className={"card-pride-ticket-content"}>
                                    <Tag>{item.eventSector}</Tag>
                                    <p className={"title"}>
                                        {item.eventName.length >= 36
                                            ? item.eventName.substring(0, 36) + "..."
                                            : item.eventName}
                                    </p>
                                    <p className={"date"}>
                                        {item.celebrationDate ? moment(item.celebrationDate).format(
                                            "DD/MM/YYYY,  HH:mm A"
                                        ) : null }
                                    </p>
                                    <p className={"location"}>{item.locationName}</p>
                                </div>
                            </Card>
                        ))}
                    </div>
                )}

                {contentType === "gallery" && (
                    <SlideshowLightbox className="blog-gallery-lightbox">
                        {contentData.map((img, i) => (
                            <img key={i} className="blog-gallery-lightbox-item" src={img.src} alt="" />
                        ))}
                    </SlideshowLightbox>
                )}

                {contentType === "prideTalks" && (
                    <Row gutter={[25, 25]}>
                        {contentData.slice(0, 4).map((item, i) => (
                            <Col xl={6} lg={8} md={8} sm={12} xs={24} key={i}>
                                <CardAudience
                                    item={item}
                                    publishedItems={true}
                                    onLive={false}
                                    publishedDate={false}
                                    handleLinkConference={handleClick}
                                />
                            </Col>
                        ))}
                    </Row>
                )}

                {contentType === "prideTalksLive" && (
                    <Row gutter={[25, 25]}>
                        {contentData.map((item, i) => (
                            <Col xl={6} lg={8} md={8} sm={12} xs={24} key={i}>
                                <CardAudience
                                    item={item}
                                    publishedItems={false}
                                    onLive={now < dayjs(item.data.endDate) && now > dayjs(item.data.conferenceDate)}
                                    publishedDate={true}
                                    handleLinkConference={handleClick}
                                />
                            </Col>
                        ))}
                    </Row>
                )}

                {contentType === "prideMusic" && (
                    <Row gutter={16}>
                        {contentData.map((item, index) => (
                            <Col key={index} xl={8} lg={12} md={12} xs={24}>
                                <PrideMusicCard item={item} />
                            </Col>
                        ))}
                    </Row>
                )}

                {contentType === "jobBank" && (
                    <Row gutter={[16,16]}>
                        {contentData.map((job, index) => (
                            <Col xl={6} lg={8} md={12} sm={12} xs={24} key={job.jobId}>
                                <ItemJobPublished
                                    jobPublished={false}
                                    job={job}
                                    index={index}
                                    misEmpl={false}
                                    userRegistered={userRegistered}
                                />
                            </Col>
                        ))}
                    </Row>
                )}

                {contentType === "directory" && (
                    <div className="directory-container-wrapper">
                        {contentData.map((item) => (
                            <ItemDirectory
                                key={item.directoryInfoId}
                                directoryItem={item}
                                isAdmin={isAdmin}
                                sectionOn={sectionOn}
                                profileId={profileId}
                                userRegistered={userRegistered}
                            />
                        ))}
                    </div>
                )}

                {
                    (contentType === "interestGroup") && (
                        <Row>
                            {contentData.map((item, index) => {
                                return (
                                    <Col xl={6} lg={8} md={12} sm={24} xs={24}>
                                        <InterestGroupCard key={index} item={item} />
                                    </Col>
                                )
                            })}
                        </Row>
                    )
                }

                {
                    (contentType === "registerServices" || contentType === "eventForm") && (
                       <></>
                    )
                }

                {!isArrayContent && (
                    <div dangerouslySetInnerHTML={{ __html: userRegistered ? content : truncatedContent }} />
                )}
            </div>

            {!userRegistered && (
                <div className={"content-blocker__content"}>
                    {
                        (isFormSuccess) ? (
                                <MessageSuccess
                                    title={dataMessageSuccess.title}
                                    description={dataMessageSuccess.description}
                                    isSuccess={statusForm}
                                    handleButtonClick={handleReset}
                                />
                            ) : (isFormRegister) ?
                            <FormRegister
                                handleCancel={() => {
                                    setIsLogin(false);
                                    setIsFormRegister(false);
                                }}
                                setMsg={setMsg}
                                msg={msg}
                                title={title}
                                handleFormSubmit={handleFormSubmit}
                                textRegister={<p className={"text-secondary"}>¿Ya estás registrade? <span onClick={() => {
                                    setIsLogin(true);
                                    setIsFormRegister(false);
                                }}>Inicia sesión</span></p>}
                            />
                            : (
                                <FormLogin
                                    isFormLogin={isFormLogin}
                                    setIsFormLogin={setIsFormLogin}
                                    handleCancel={() => {
                                        setIsLogin(false);
                                        setIsFormRegister(false)
                                    }}
                                    setMsg={setMsg}
                                    msg={msg}
                                    title={title}
                                    handleFormSubmit={handleFormSubmit}
                                    textRegister={<p className={"text-secondary"}>¿Aún no tienes una cuenta? <span onClick={() => {
                                        setIsLogin(false);
                                        setIsFormRegister(true);
                                    }}>Regístrate</span></p>}
                                />
                            )
                        }
                </div>
            )}
        </>
    );
};

export default ContentBlocker;
